<div class="two-fa-verification-dialog m-4">
  <h3 mat-dialog-title>2-Step Verification</h3>
  <mat-dialog-content class="pt-2">
    <div class="row text-center">
      <div class="col-lg-12 col-md-7 instruction-text">
        Enter the 6-digit verification code sent via {{otpDeliveryMethod}}

         @if(otpDeliveryMethod === 'sms') {
          to your registered mobile number +61 ****{{mobileLast4Digits}}.
         } @else {
          to your registered email address ({{ authenticationValue }}).
         }
        Please verify to continue.
      </div>
    </div>

    <!-- Error Message -->
    @if(errorMessage) {
      <div class="row mt-3">
        <div class="col-12">
          <div class="alert alert-danger" role="alert">
            <strong>{{ errorMessage }}</strong>
          </div>
        </div>
      </div>
    }

    <div class="row mt-4">
      <div class="col-12">
        <form (ngSubmit)="onVerify2FA($event)">
          <div class="otp-input-container">
            <input
              *ngFor="let control of digitControls; let i = index"
              [id]="'digit-' + i"
              [formControl]="control"
              type="text"
              inputmode="numeric"
              maxlength="1"
              class="otp-digit-input"
              (input)="onDigitInput($event, i)"
              (keydown)="onDigitKeyDown($event, i)"
              (paste)="onDigitPaste($event)"
              autocomplete="off"
            />
          </div>
          <button type="submit" style="display: none;"></button>
        </form>
      </div>
    </div>

    <!-- Resend Code Button -->
    <div class="row mt-2">
      <div class="col-12 text-center">
        <button 
          mat-button 
          color="primary" 
          (click)="onResendCode()"
          [disabled]="!canResend"
          type="button"
        >
          {{ resendButtonText }}
        </button>
      </div>
    </div>

    <div class="row mt-3">
      <div
        fxFlex="1 1 auto"
        fxLayout="column"
        fxLayout.lt-md="column"
        fxLayoutAlign="center center"
        fxLayoutAlign.lt-md="center center"
      >
        <span><strong>Phone:</strong> 1300 001 420</span>
        <span><strong>Email:</strong> <a href="mailto:support&#64;dynamoney.com"> support&#64;dynamoney.com</a></span>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="width-100" fxLayout="row" fxLayoutAlign="space-between">
      <button mat-stroked-button (click)="onCancel()" [disabled]="isVerifying">Cancel</button>
      <button
        mat-flat-button
        color="primary"
        (click)="onVerify2FA($event)"
        [disabled]="!otpForm.valid || isVerifying || isBlocked"
      >
        @if(isVerifying) {
          <span>Verifying...</span>
        } @else {
          <span>Verify and Continue</span>
        }
      </button>
    </div>
  </mat-dialog-actions>
</div>